import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import CloudOptixMappingForm from './CloudOptixMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function CloudOptixCredentialForm(props, ref) {
    const fields = useMemo(() => (
        [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator],
        }, {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }]
    ),[])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={CloudOptixMappingForm}
            initialValue={{ apiEndpoint: 'https://optix.sophos.com' }}
        />
    )
}

export default forwardRef(CloudOptixCredentialForm);